import {
    GENERATEMERCHANTWIRELIST_SUCCESS,
    GENERATEMERCHANTWIRELIST_FAILED,
    RESET_GENERATEMERCHANTWIRELIST,
    LOADING_GENERATEMERCHANTWIRELIST,
    NETWORK_ERROR_GENERATEMERCHANTWIRELIST
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGenerateMerchantWireList = () => {
    return { type: RESET_GENERATEMERCHANTWIRELIST };
};

const generateMerchantWireList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GENERATEMERCHANTWIRELIST });
    await partnerServices
        .post("generateMerchantWireReportList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(generateMerchantWireListsuccess(res.data));
                    break;
                default:
                    dispatch(generateMerchantWireListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GENERATEMERCHANTWIRELIST,
                payload: err
            });
        });
};
function generateMerchantWireListsuccess(data) {
    return {
        type: GENERATEMERCHANTWIRELIST_SUCCESS,
        payload: data
    };
}
function generateMerchantWireListFailed(data) {
    return {
        type: GENERATEMERCHANTWIRELIST_FAILED,
        payload: data
    };
}

export { resetGenerateMerchantWireList, generateMerchantWireList };
